export default __webpack_public_path__ + "static/media/2nd.fb8f5247.svg";